import { createFileRoute } from "@tanstack/react-router";
import { VolunteerInviteCard } from "@/components/volunteers/volunteer-invite-card";
import { VolunteerTable } from "@/components/volunteers/volunteer-table";
import { useSession } from "@/hooks/use-session";

export const Route = createFileRoute("/_app/_/volunteers/")({
	component: VolunteersPage,
});

function VolunteersPage() {
	const session = useSession();
	const campaignId = session.campaign?.id ?? 0;

	if (!campaignId) {
		return (
			<div className="min-h-screen bg-background p-6">
				<div className="mx-auto max-w-7xl">
					<p className="text-muted-foreground">
						No campaign found. Please complete onboarding first.
					</p>
				</div>
			</div>
		);
	}

	return (
		<div className="min-h-screen bg-background p-6">
			<div className="mx-auto max-w-7xl space-y-6">
				<div className="space-y-4">
					<div>
						<h1 className="text-2xl font-bold">Volunteers</h1>
						<p className="text-sm text-muted-foreground">
							Manage your campaign volunteers
						</p>
					</div>
					<VolunteerInviteCard
						slug={session.campaign?.slug}
						visibility={session.campaign?.visibility}
					/>
					<VolunteerTable campaignId={campaignId} />
				</div>
			</div>
		</div>
	);
}
